import * as z from "zod/v4";
import { rateGridSchema } from "./rate-grid-schema";

export const getHistoricalShipmentRates = {
  name: "getHistoricalShipmentRates" as const,
  input: z.object({ teamId: z.string(), limit: z.number().optional() }),
  output: z.object({
    success: z.boolean(),
    rateGrid: rateGridSchema.nullable(),
    totalShipments: z.number(),
    serviceLevelStats: z
      .object({ Standard: z.number(), Plus: z.number(), Express: z.number() })
      .nullable(),
    oldestShipmentDate: z.string().nullable(),
    newestShipmentDate: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
